import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { ServiceChargesService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Promotions } from '../../models'

const log = new Logger('ServiceChargesDetailResolver')
@Injectable({ providedIn: 'root' })
export class ServiceChargesDetailResolver implements Resolve<Observable<Promotions>> {
  constructor(private serviceChargesService: ServiceChargesService, private router: Router) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let id = route.params['id']
    
    return this.serviceChargesService.getDetail(id).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/service-charges']))
    )
  }
}
